<div class="holder">
  <p class="default-paragraph p-3">
    Cancelling all current user's subscriptions for property at project list, please wait...
  </p>
</div>
